import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete } from '@material-ui/lab';
import StyledTextField from '../ui/StyledTextField';

const StoneAutocomplete = forwardRef(({
    listePierre,
    value,
    onChange,
    onEnter
}, ref) => {
    const [inputValue, setInputValue] = useState('');
    const [open, setOpen] = useState(false);

    const filterOptions = (options, { inputValue }) => {
        const terms = inputValue.toLowerCase().split(' ').filter(t => t);
        return options.filter(option => {
            const desc = option.descriptionPierre.toLowerCase();
            return terms.every(term => desc.includes(term));
        });
    };

    return (
        <Autocomplete
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            options={listePierre || []}
            getOptionLabel={option => option.descriptionPierre || ''}
            value={value || null}
            onChange={(_, val) => onChange(val)}
            inputValue={inputValue}
            onInputChange={(_, val) => setInputValue(val)}
            getOptionSelected={(option, val) =>
                option.id_pier === val.id_pier && option.id_qual === val.id_qual
            }
            filterOptions={filterOptions}
            renderInput={(params) => (
                <StyledTextField
                    {...params}
                    label="Pierre"
                    variant="outlined"
                    size="small"
                    inputRef={ref}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();

                            let selected = value;
                            const filtered = filterOptions(listePierre || [], { inputValue });

                            if (!selected && filtered.length > 0) {
                                selected = filtered[0];
                                onChange(selected);
                            }

                            // fermer la liste comme si on avait cliqué sur une option
                            setOpen(false);

                            // déclencher la validation
                            onEnter();
                        }
                    }}
                />
            )}
        />
    );
});

StoneAutocomplete.propTypes = {
    listePierre: PropTypes.array.isRequired,
    value: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onEnter: PropTypes.func.isRequired,
};

export default StoneAutocomplete;
